import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { environment } from 'src/environments/environment';

/**
 * Bloquea la ruta de "Etiquetas de prueba" en entornos productivos.
 * Solo se permite si environment.showTestLabels es true; en caso contrario
 * redirige al inicio (evita el acceso por URL directa en PRO).
 */
@Injectable()
export class TestLabelsGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(): boolean | UrlTree {
    if (environment.showTestLabels) {
      return true;
    }
    return this.router.parseUrl('/index');
  }
}
